import classNames from 'classnames';
import React from 'react';
import './faq.scss';

const faqTitleContainerClasses = classNames(
    'l-align-left',
    'eds-g-cell-12-12',
    'eds-g-cell-mn-4-12',
    'eds-g-cell-md-4-12',
    'faq-title',
);
const faqTitleClasses = classNames(
    'eds-text-color--grey-900',
    'eds-text-hm',
    'eds-text--left',
    'mktg-text-weight--heavy',
    'eds-l-sm-pad-right-0',
    'eds-l-pad-right-8',
    'eds-l-pad-bot-6',
);
const answerListClasses = classNames(
    'js-xd-accordion-content',
    'simple-accordion-content',
    'eds-l-pad-bot-6',
);
const questionClasses = classNames(
    'js-xd-accordion-header',
    'simple-accordion-header',
    'eds-text-bl',
    'eds-text-color--grey-900',
    'eds-l-pad-vert-6',
);
const answerClasses = classNames(
    'faq-module-answers',
    'eds-text-bm',
    'eds-text-color--grey-700',
    'eds-l-pad-hor-6 faq-body',
);

interface Question {
    question: string;
    answer: string;
}

const QuestionComponent = (question: Question) => (
    <div className="faq-question">
        <h3 className={questionClasses}>{question.question}</h3>
        <ul className={answerListClasses}>
            <div className="eds-l-mar-top-3">
                <div className="mktg-layout-align--horizontal">
                    <div
                        className={answerClasses}
                        dangerouslySetInnerHTML={{
                            __html: question.answer,
                        }}
                    ></div>
                </div>
            </div>
        </ul>
    </div>
);

interface QuestionListProps {
    questions: Question[];
}
const QuestionList = ({ questions }: QuestionListProps) => (
    <div
        className="js-d-accordion simple-accordion "
        data-d-aria-director-role="tab"
        data-d-aria-view-role="tabpanel"
        style={{ position: 'relative', zIndex: 100 }}
    >
        {questions.map((question, idx) => (
            <QuestionComponent key={idx} {...question} />
        ))}
    </div>
);

export interface FaqModuleProps {
    title: string;
    questions: Question[];
}
const FAQModule = ({ title, questions }: FaqModuleProps) => (
    <section
        data-testid="faq-module"
        className="marketing-container__max-width mktg-top-p-100 eds-l-pad-hor-6"
    >
        <div className="mktg-layout-align--horizontal-desktop ">
            <div className={faqTitleContainerClasses}>
                <h2
                    className={faqTitleClasses}
                    style={{ position: 'relative', zIndex: 100 }}
                >
                    {title}
                </h2>
            </div>
            <div className="eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-g-cell-md-8-12 ">
                <QuestionList questions={questions} />
            </div>
        </div>
    </section>
);

export default FAQModule;
